import { getJSONfromString } from "./objectUtils";
import CloudpassService from "../services/cloudpassService";
import AffiliatesService from "../services/affiliatesService";

export const errorHandling = async (
  e: any, 
  cloudPassService: CloudpassService, 
  affiliatesService: AffiliatesService, 
  configState: any,
  setError?: (error: any) => void
) => {
  console.error(e);
  if (e instanceof Error) {
    let errorObj = getJSONfromString(e.message);
    if (errorObj?.statusCode === 451 || errorObj?.status === 451) {
      window.location.replace('/error/geoblocking');
    }

    const authErrorCodes = ['AFF-030', 'TKN-API-ERR', 'CP-006', 'CP-API-ERR', 'AFF-065', 'JWT-ERR'];
    const code = errorObj?.error?.code || errorObj?.error?.errorCode || errorObj?.code;
    if (authErrorCodes.includes(code)) {
      localStorage.removeItem('jwtSession');
      await cloudPassService?.logout();
      const oauthURL = cloudPassService?.getOauth2LoginURL({
        countryCode: configState!.countryCode!,
        idpShortName: configState!.idp!,
        redirectURL: affiliatesService?.getBindingInitializationURL()!
      });
      window.location.replace(oauthURL!);
      return;
    }
  }
  if (setError) {
    setError(e);
  }
}